import React, { Component } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import http from "../../../services/HttpService";
import Route from "../../../Routes";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

import MetaTags from 'react-meta-tags';
import Helmet from 'react-helmet';
import Logo_b from "../../../../assets/img/site/Logo.png";

import "../../../../assets/scss/style/dashboard/_homePage.scss"

import i18next from 'i18next';
import { Translation } from "react-i18next";

import LayoutMaster from "../../../views/layout/Master";
import { layout } from "../../../../ts-helpers/decorators";
import swal from "sweetalert2";
import { Redirect } from "react-router";
import validate from "../../../services/ValidationService";
import Header from "../Header";
import SearchBoard from "../SearchBoard";


@layout(LayoutMaster)
class HomePage extends Component<any> {
    animating = false;

    state = {
        loading: false,
        updated: false,
        first: null,
        second: true,
        third: null,
        industries: [],
        industry_value: null,
        mouseOver:null,
        specializations: [],
        specialization_value: null,

        keyword_value: '',
        query: '',
        check: false,


    };

    componentDidMount() {
        this.getIndustry();
        console.log(this.state.mouseOver)
        this.handleChangeIndustry;
        //this.props.onRef(this);
    }

    @autobind
    getIndustry() {
        http.get(`/industries/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    industries: data,
                });
            });
    }

    @autobind
    handleChangeIndustry(industry_value) {
        console.log("industry_value-", industry_value);
        industry_value !== null ?
            http.get(`/industries/getById/${industry_value.value}`)
                .then(response => response.json())
                .then((data) => {
                    let a = { key: industry_value.key, value: industry_value.value, label: industry_value.label.replace(/\//g, "-") }
                    this.setState({
                        specializations: data.specializations,
                        industry_value: a,
                        specialization_value: null,
                    });
                })
            : this.setState({
                industry_value: null,
                specializations: [],
                specialization_value: null,
            });
    }

    @autobind
    handleChangeSpecialization(specialization_value) {
        this.setState({
            specialization_value,
        });
    }

    @autobind
    handleChangeKeyword(event) {
        const keyword_value = event.target.value;
        this.setState({
            keyword_value,
        });
    }

    @autobind
    search(event) {
        event.preventDefault();

        const { industry_value, specialization_value, keyword_value } = this.state;

        const query = JSON.stringify({
            industry_value: industry_value,
            specialization_value: specialization_value,
            keyword_value: keyword_value,
        });

        this.setState({
            updated: true,
            query: query,
        });
    }

    @autobind
    handleCheck() {
        this.setState({ check: !this.state.check });
    }

    @autobind
    handleCheck_1() {
        this.setState({ check: !this.state.check });
    }

    mouseOverChange = (e) => {
       
      this.setState({mouseOver:e})
      

    }
    mouseOverEnd = (e) => {
        this.setState({mouseOver:null })
    }
    render() {
        const { updated, industries, industry_value, specializations, specialization_value, keyword_value, query, check } = this.state;

        if (updated) {
            return <Redirect to={Route.toUrl("search", { query: query })} />
        }

        return (
            <div>
                <SearchBoard />

                <div className="container">

                    <div className="firstBlock">
                        <h3>Popular Industries</h3>
                        <div className="industriesGroup">
                            {this.state.industries.map((elem, i) => {
                                if (i == 2 || i == 5 || i == 8) {
                                    return (<div key={i} onMouseOver={this.mouseOverChange.bind(this,i)} onMouseLeave={this.mouseOverEnd} id="third" className={this.state.mouseOver==i ? "third-active" : "third"}>
                                        <img src="/design.png" />
                                        <h4>Design</h4>
                                        <Link to={Route.toUrl("search", { query: JSON.stringify({ "industry_value": { "key": i, "value": elem._id, "label": elem.i_name }, "specialization_value": null, "keyword_value": "" }).replace(/\//g, "-") })}>
                                            <button className="learnMore">Learn More</button>
                                        </Link>
                                    </div>)
                                }
                                if (i == 0 || i == 3 || i == 6) {
                                    return (
                                        <div key={i} onMouseOver={this.mouseOverChange.bind(this,i)} onMouseLeave={this.mouseOverEnd} id="first" className={this.state.mouseOver==i ? "first-active" : "first"}>
                                            <img src="/managment.png" />
                                            <h4>{elem.i_name}</h4>
                                            <Link to={Route.toUrl("search", { query: JSON.stringify({ "industry_value": { "key": i, "value": elem._id, "label": elem.i_name }, "specialization_value": null, "keyword_value": "" }).replace(/\//g, "-") })}>
                                                <button className="learnMore">Learn More</button>
                                            </Link>

                                        </div>
                                    )
                                }
                                if (i == 1 || i == 4 || i == 7) {
                                    return (

                                        <div key={i} onMouseOver={this.mouseOverChange.bind(this,i)} onMouseLeave={this.mouseOverEnd} id="second" className={ this.state.mouseOver==i  ? "second" : this.state.mouseOver==i+1 || this.state.mouseOver==i-1 ? "second-active":"second" }>
                                            <img src="/startup.png" />
                                            <h4>Startup</h4>
                                            <Link to={Route.toUrl("search", { query: JSON.stringify({ "industry_value": { "key": i, "value": elem._id, "label": elem.i_name }, "specialization_value": null, "keyword_value": "" }).replace(/\//g, "-") })}>
                                                <button className="learnMore">Learn Msore</button>
                                            </Link>
                                        </div>
                                    )
                                }
                                return (
                                    <div key={i} onMouseOver={this.mouseOverChange.bind(this,i)} onMouseLeave={this.mouseOverEnd} id="second" className={ this.state.mouseOver==i  ? "second" : this.state.mouseOver==i+1 || this.state.mouseOver==i+1 ? "second-active":"second" }>
                                        <img src="/startup.png" />
                                        <h4>{elem.i_name}</h4>
                                        <Link to={Route.toUrl("search", { query: JSON.stringify({ "industry_value": { "key": i, "value": elem._id, "label": elem.i_name }, "specialization_value": null, "keyword_value": "" }).replace(/\//g, "-") })}>
                                            <button className="learnMore">Learn More</button>
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>



                    </div>
                    <div className="secondBlock">
                        <img src="/secondBlockImg.png" />
                        <h5>
                            Find the software
                            faster an speed
                            up the software
                            familiarization
                            process.
                    </h5>
                    </div>
                    <div className="thirdBlock">
                        <h5>
                            Share your software
                            experience to help
                            others make great
                            choices
                    </h5>
                        <img src="/thirdBlockImg.png" />

                    </div>
                </div>
            </div>
        );
    }
}

export default HomePage;
